export const EU_MARKET_COUNTRY_CODES = [
	"FR",
	"ES",
	"IT",
	"DE",
	"BE",
	"NL",
] as const;
export type EuMarketCountryCode = (typeof EU_MARKET_COUNTRY_CODES)[number];

export function isEuMarketUser(countryCode: string): boolean {
	return EU_MARKET_COUNTRY_CODES.includes(countryCode as EuMarketCountryCode);
}

/**
 * Supplier whose inventory is treated as "new cars" in the filter & badges.
 * Currently only available in Continental Europe.
 */
export const NEW_CARS_SUPPLIER = "Neuwagenkontor";

/**
 * Returns effective countryCodes for API calls.
 * - Non-EU user → undefined (API uses single countryCode)
 * - EU user, no filter → all EU market codes
 * - EU user, filter selected → only those codes
 */
export function getEffectiveCountryCodes(
	userCountryCode: string,
	selectedMarkets?: string[]
): string[] | undefined {
	if (!isEuMarketUser(userCountryCode)) return undefined;
	if (selectedMarkets?.length) return selectedMarkets;
	return [...EU_MARKET_COUNTRY_CODES];
}
